import React from "react";

import { ChatBubble } from "./chat-bubble";

export const SessionErrorDisplay: React.FC<{
	message: string;
	onRetry?: () => void;
	variant?: "error" | "system";
}> = ({ message, onRetry, variant = "error" }) => (
	<ChatBubble variant={variant}>
		<p>{message}</p>
		{onRetry && (
			<button
				className="mt-2 cursor-pointer rounded-md border border-red-300 bg-white px-3 py-1 text-red-700 text-xs hover:bg-red-50"
				onClick={onRetry}
				type="button"
			>
				Retry
			</button>
		)}
	</ChatBubble>
);
